import advancedSearchesStore from '@/utils/searches_store/advanced_search'
import { redirectWithoutNavigationGuardError } from './base'

export default ({ redirect, route }) => {
  if(Object.keys(route.query).length > 0) return

  const filters = advancedSearchesStore.read()
  if (filters) {
    redirectWithoutNavigationGuardError(redirect, {
      path: '/advanced_search', query: { ...filters }
    })
  }
}